import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import { deletePassportNumber } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import { Label, LabelText } from '../../../../components/EnrollForm/EnrollFormStyles';
import Input from '../../../../../CommonComponents/Input';
import ExperianContext from '../../../../ExperianContext';

const PassportNumber = ({ title, data }) => {
  const [passportNumberToDelete, setPassportNumberToDelete] = useState(null);
  const [confirmationNumber, setConfirmationNumber] = useState('');

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deletePassportNumber(clientId, subscriberId, confirmationNumber));
    setPassportNumberToDelete(null);
    setConfirmationNumber('');
  }, [clientId, subscriberId, confirmationNumber, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            <DataItem>
              <DeleteIcon onClick={() => setPassportNumberToDelete(data)} />
              <DataItemText>{data}</DataItemText>
            </DataItem>
          </ItemContent>
        </div>
        {!!passportNumberToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => {
              setPassportNumberToDelete(null);
              setConfirmationNumber('');
            }}
            isConfirmDisabled={confirmationNumber.length === 0}
          >
            <Label>
              <LabelText>Enter your passport number below to confirm:</LabelText>
              <Input
                value={confirmationNumber}
                onChange={ev => setConfirmationNumber(ev.target.value)}
                type="text"
                size="small"
              />
            </Label>
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default PassportNumber;
